"use strict";

var _regeneratorRuntime = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/workpath0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_addons_1 = require("rxjs-addons");

var rxjs_1 = require("rxjs");

var operators_1 = require("rxjs/operators");

var State = /*#__PURE__*/function () {
  function State() {
    _classCallCheck(this, State);

    this.initialized$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.connected$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.authenticated$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.account$ = new rxjs_addons_1.UniqueBehaviorSubject(null, {
      prepare: function prepare(newValue, oldValue) {
        if (newValue && oldValue && !newValue.balance.real && oldValue.balance.real) {
          newValue.balance.real = oldValue.balance.real;
        }

        return newValue;
      }
    });
    this.accountDevice$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.accountFriendRecovery$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.device$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.ens$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.eth$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.session$ = new rxjs_addons_1.UniqueBehaviorSubject();
    this.incomingAction$ = new rxjs_addons_1.UniqueBehaviorSubject(); //
  }

  _createClass(State, [{
    key: "setup",
    value: function setup(storage) {
      return Promise.all([Promise.resolve(this.session$.pipe(operators_1.map(function (session) {
        return !!session;
      })).subscribe(this.authenticated$)), this.attachToStorage(storage, this.account$, State.StorageKeys.Account), this.attachToStorage(storage, this.accountDevice$, State.StorageKeys.AccountDevice), this.attachToStorage(storage, this.accountFriendRecovery$, State.StorageKeys.AccountFriendRecovery)]);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.initialized$.next(null);
      this.connected$.next(null);
      this.authenticated$.next(null);
      this.account$.next(null);
      this.accountDevice$.next(null);
      this.accountFriendRecovery$.next(null);
      this.device$.next(null);
      this.ens$.next(null);
      this.eth$.next(null);
      this.session$.next(null);
      this.incomingAction$.next(null);
    }
  }, {
    key: "attachToStorage",
    value: function attachToStorage(storage, subject, key) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return storage.getItem(key);

              case 2:
                value = _context.sent;

                if (value) {
                  subject.next(value);
                }

                return _context.abrupt("return", subject.pipe(operators_1.skip(1), operators_1.switchMap(function (value) {
                  return rxjs_1.from(storage.setItem(key, value).catch(function () {
                    return null;
                  }));
                })).subscribe());

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
    }
  }, {
    key: "initialized",
    get: function get() {
      return this.initialized$.value;
    }
  }, {
    key: "connected",
    get: function get() {
      return this.connected$.value;
    }
  }, {
    key: "authenticated",
    get: function get() {
      return this.authenticated$.value;
    }
  }, {
    key: "account",
    get: function get() {
      return this.account$.value;
    }
  }, {
    key: "accountAddress",
    get: function get() {
      var value = this.account$.value;
      return value ? value.address : null;
    }
  }, {
    key: "accountDevice",
    get: function get() {
      return this.accountDevice$.value;
    }
  }, {
    key: "accountFriendRecovery",
    get: function get() {
      return this.accountFriendRecovery$.value;
    }
  }, {
    key: "device",
    get: function get() {
      return this.device$.value;
    }
  }, {
    key: "deviceAddress",
    get: function get() {
      var value = this.device$.value;
      return value ? value.address : null;
    }
  }, {
    key: "ens",
    get: function get() {
      return this.ens$.value;
    }
  }, {
    key: "eth",
    get: function get() {
      return this.eth$.value;
    }
  }, {
    key: "session",
    get: function get() {
      return this.session$.value;
    }
  }, {
    key: "sessionToken",
    get: function get() {
      var value = this.session$.value;
      return value ? value.token : null;
    }
  }, {
    key: "incomingAction",
    get: function get() {
      return this.incomingAction$.value;
    }
  }]);

  return State;
}();

exports.State = State;

(function (State) {
  var StorageKeys;

  (function (StorageKeys) {
    StorageKeys["Account"] = "account";
    StorageKeys["AccountDevice"] = "account_device";
    StorageKeys["AccountFriendRecovery"] = "account_friend_recovery";
  })(StorageKeys = State.StorageKeys || (State.StorageKeys = {}));
})(State = exports.State || (exports.State = {}));